"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetViews = exports.deleteManyViews = exports.deletedOneView = exports.updatedManyViews = exports.updatedOneView = exports.gotManyViews = exports.gotOneView = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneView = gotOne;
exports.gotManyViews = gotMany;
exports.updatedOneView = updatedOne;
exports.updatedManyViews = updatedMany;
exports.deletedOneView = deletedOne;
exports.deleteManyViews = deleteMany;
exports.resetViews = reset;
//# sourceMappingURL=actions.js.map